import API from "../API";
import setIfNotSet from "../../setIfNotSet";
import getUrl from "./utils/getUrl";
import setOperationNameToParams from "./utils/setOperationNameToParams";
import appendApolloClientValues from "./utils/appendApolloClientValues";
/** @author: Richard Scoones 22/8/2018
 * @desc: Used by apollo to make requests instead of fetch
 */
export default {
    request: function (config) {
        if (config === void 0) { config = {}; }
        setIfNotSet(config, "isApolloQuery", true);
        // Need to make sure we re-evaluate region url on each request
        config.url = getUrl();
        // Add non-functional query param of the operation name
        setOperationNameToParams(config);
        return appendApolloClientValues(config).then(function () {
            return API.request(config);
        });
    }
};
